__turbopack_context__.v({
  "inclFeesAndShippingText": "yXwEGq_inclFeesAndShippingText",
  "includingFeesText": "yXwEGq_includingFeesText",
  "infoIconButton": "yXwEGq_infoIconButton",
  "originalPrice": "yXwEGq_originalPrice",
  "originalPriceStrikethrough": "yXwEGq_originalPriceStrikethrough",
  "priceWithFeeWrapper": "yXwEGq_priceWithFeeWrapper",
});
